import script from "./recent-conversations.vue?vue&type=script&setup=true&lang=js"
export * from "./recent-conversations.vue?vue&type=script&setup=true&lang=js"

import "./recent-conversations.vue?vue&type=style&index=0&id=73bddcfb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73bddcfb"]])

export default __exports__